import {
  Button,
  Card,
  CardHeader,
  Text,
  Title3,
  makeStyles,
  tokens,
} from "@fluentui/react-components";
import { LockClosed24Regular } from "@fluentui/react-icons";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    padding: "24px",
    gap: "24px",
  },
  logo: {
    width: "48px",
    height: "48px",
    borderRadius: "12px",
    background: `linear-gradient(135deg, #6366F1, #8B5CF6)`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: "22px",
    fontWeight: 800,
  },
  card: {
    width: "100%",
    maxWidth: "280px",
    padding: "24px",
    textAlign: "center" as const,
  },
  description: {
    color: tokens.colorNeutralForeground3,
    marginTop: "8px",
    marginBottom: "20px",
  },
});

interface LoginViewProps {
  onLogin: () => void;
}

export function LoginView({ onLogin }: LoginViewProps) {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <div className={styles.logo}>B</div>
      <Card className={styles.card}>
        <Title3 align="center">Bolsterup</Title3>
        <Text className={styles.description} size={200} block>
          Sign in with your Microsoft account to access your Bolsterup projects
          and AI assistant.
        </Text>
        <Button
          appearance="primary"
          icon={<LockClosed24Regular />}
          onClick={onLogin}
          style={{
            width: "100%",
            background: "linear-gradient(135deg, #6366F1, #8B5CF6)",
          }}
        >
          Sign in with Microsoft
        </Button>
      </Card>
    </div>
  );
}
